const typeCodes = {
  RANGE: 133,
  STATIC: 134,
  MULTIPLE_VALUE: 316,
};

export default typeCodes;
